import { CreatableOption, MuiMultiSelectProps, MuiSingleSelectProps, OptionTypeWithCode } from '../../types';
import { isObject } from '../../../../utils/guards';

export function isMultiSelect<VALUE>(
  props: MuiMultiSelectProps<VALUE> | MuiSingleSelectProps<VALUE>
): props is MuiMultiSelectProps<VALUE> {
  return (props as MuiMultiSelectProps<VALUE>).multiple;
}

export function isCreatableOption(option?: unknown): option is CreatableOption {
  return !!option && isObject(option) && !!(option as CreatableOption).creatableValue;
}

export function isOptionTypeWithCode<OPTION extends OptionTypeWithCode>(option?: unknown): option is OPTION {
  return !!option && isObject(option) && !!(option as CreatableOption).label;
}
